import { Icon, IconProps } from "../";

export const CommentIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22H3C2.7 22 2.5 21.9 2.3 21.7C1.9 21.3 1.9 20.7 2.3 20.3L4.3 18.3C2.8 16.5 2 14.3 2 12ZM7 12C7 12.6 7.4 13 8 13C8.6 13 9 12.6 9 12C9 11.4 8.6 11 8 11C7.4 11 7 11.4 7 12ZM12 13C11.4 13 11 12.6 11 12C11 11.4 11.4 11 12 11C12.6 11 13 11.4 13 12C13 12.6 12.6 13 12 13ZM15 12C15 12.6 15.4 13 16 13C16.6 13 17 12.6 17 12C17 11.4 16.6 11 16 11C15.4 11 15 11.4 15 12Z"
      />
    </Icon>
  );
};
